import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import PathScheduleLabel from "@pathwright/web/src/modules/path/ui/PathScheduleLabel"
import ItemPublishStatus from "library/show/components/publish/ItemPublishStatus"
import { DESIGN, LEARN } from "path/constants"
import * as dateUtils from "path/utils"
import PeopleHere from "../analytics/PeopleHere"
import "./PathStepMeta.css"

const PathStepMeta = function (props) {
  const { item, mode, status, analytics, t } = props

  let estTimeLabel = null
  if (item.time_to_complete) {
    estTimeLabel = dateUtils.getEstimatedTimeDisplay(item.time_to_complete, t)
  }

  const onlyLearner =
    mode === LEARN && !!analytics && analytics.next_count === 1

  const pendingReview =
    item &&
    item.completion.progress === 1.0 &&
    item.completion.item_needs_grading

  return (
    <div className="PathStepMeta">
      {mode < DESIGN && !onlyLearner && (
        <PeopleHere item={item} size="small" limit={5} />
      )}
      <div className="PathStepMeta__info">
        {status === "completed" ? (
          <span>
            <Pathicon icon={pendingReview ? "check-dash" : "check"} />
            <span> </span>
            {t("step.completed")}
          </span>
        ) : status === "skipped" ? (
          <span>
            <Pathicon icon="skip" />
            <span> </span>
            {t("step.skipped")}
          </span>
        ) : !item.is_required ? (
          <span>{t("step.optional")}</span>
        ) : null}
        {!!estTimeLabel && <span>{estTimeLabel}</span>}
        {item.userpoints_value > 0 && (
          <span>
            {item.userpoints_value} {t("step.points")}
          </span>
        )}
        {mode === DESIGN && (
          <span>
            <ItemPublishStatus item={item} />
          </span>
        )}
        {mode === LEARN && (
          <span>
            <PathScheduleLabel pathItem={item} showIcon />
          </span>
        )}
      </div>
    </div>
  )
}

PathStepMeta.displayName = "PathStepMeta"

export default withTranslate(PathStepMeta)
